import React, { useState, useCallback, useMemo } from "react";
import LivePl from "../LivePl/LivePl";

const fmt = require("indian-number-format");

export default function StandingCard({ item, userType }) {
  const [pfData, setPfData] = useState([]);
  const [total, setTotal] = useState(0);
  const [adminTotal, setAdminTotal] = useState(0);

  const admin_sharing = item.admin_sharing;

  /** 🔹 Handlers to open edit modals */
  const OpenEditSuper = () => {
    window.user_id = item.super_id;
    window.openeditSuper?.();
  };

  const OpenEditMaster = () => {
    window.user_id = item.id;
    window.masterModalOpen?.();
  };

  /** 🔹 Handle Live P/L Updates (called from <LivePl/>) */
  const LivePlTotal = useCallback((id, pf, admin_pf) => {
    setPfData((prev) => {
      const existingIndex = prev.findIndex((entry) => entry.id === id);
      let updated = [];

      if (existingIndex === -1) {
        updated = [...prev, { id, pf, admin_pf }];
      } else {
        updated = prev.map((entry, idx) =>
          idx === existingIndex ? { ...entry, pf, admin_pf } : entry
        );
      }

      // ✅ Compute totals in one go
      const totals = updated.reduce(
        (acc, cur) => {
          acc.pf += parseFloat(cur.pf) || 0;
          acc.admin_pf += parseFloat(cur.admin_pf) || 0;
          return acc;
        },
        { pf: 0, admin_pf: 0 }
      );

      setTotal(totals.pf);
      setAdminTotal(totals.admin_pf);

      return updated;
    });
  }, []);

  /** 🔹 Derived values */
  const netTotal = useMemo(() => {
    return (parseFloat(total || 0) + parseFloat(item.profit_loss || 0)).toFixed(
      0
    );
  }, [total, item.profit_loss]);

  /** 🔹 Conditional color helper */
  const colorClass = (val) => (val >= 0 ? "buytext" : "selltext");

  return (
    <li className="menuContainer text addHight">
      {/* 🔸 Render Live P/L items */}
      {Array.isArray(item.standing) &&
        item.standing.map((i) => (
          <LivePl
            key={i.id}
            item={i}
            LivePlTotal={LivePlTotal}
            admin_sharing={admin_sharing}
          />
        ))}

      {/* 🔸 User Details */}
      {userType === 1 && (
        <div onClick={OpenEditSuper} className="menuExchange uppercase">
          <div className="user_id">{item.super_username}</div>
        </div>
      )}

      <div onClick={OpenEditMaster} className="menuExchange uppercase">
        <div className="user_id">{item.username}</div>
      </div>

      {/* 🔸 P/L Columns */}
      <div className={`menuExchange ${colorClass(item.profit_loss)}`}>
        {fmt.format(item.profit_loss)}
      </div>

      <div className={`menuExchange ${colorClass(total)}`}>
        {fmt.format((total || 0).toFixed(0))}
      </div>

      <div className={`menuExchange ${colorClass(netTotal)}`}>
        {fmt.format(netTotal)}
      </div>

      <div className={`menuExchange ${colorClass(-adminTotal)}`}>
        {fmt.format((Math.abs(adminTotal) || 0).toFixed(0))}
      </div>
    </li>
  );
}
